import { useTheme } from '@emotion/react';
import { Check, HexagonOne } from '@icon-park/react';
import { memo } from 'react';

import { TYPOGRAPHY_VARIANTS, Typography } from '@didaskill/ui/design-system';

import * as styles from './QuestDialog.styles';

const QuestActionBase = ({ title, isCompleted }: { title: string; isCompleted: boolean }) => {
  const theme = useTheme();

  return (
    <div css={styles.action(theme, isCompleted)}>
      {isCompleted ? (
        <Check size={16} fill={theme.colors.success[500]} strokeWidth={8} />
      ) : (
        <HexagonOne
          theme="outline"
          fill={[theme.colors.gray[500], theme.colors.gray[100]]}
          size={18}
        />
      )}
      <Typography
        variant={
          isCompleted
            ? TYPOGRAPHY_VARIANTS.BODY_MEDIUM_BOLD
            : TYPOGRAPHY_VARIANTS.BODY_MEDIUM_REGULAR
        }
      >
        {title}
      </Typography>
    </div>
  );
};

QuestActionBase.displayName = 'QuestAction';

export const QuestAction = memo(QuestActionBase);
